import { jsx as o } from "react/jsx-runtime";
import { useContext as e } from "react";
import { Context as i } from "../context.js";
import { IconButton as l } from "../../IconButton/IconButton.js";
import { Close as n } from "../../../foundations/icons/Close.js";
const c = ({ className: t }) => {
  const { onClose: r } = e(i);
  return /* @__PURE__ */ o(
    l,
    {
      ariaLabel: "Close dialog",
      tooltipOverride: "Close",
      onClick: r,
      className: t,
      disableTooltipOnFocus: !0,
      children: /* @__PURE__ */ o(n, {})
    }
  );
};
export {
  c as ModalCloseButton
};
//# sourceMappingURL=ModalCloseButton.js.map
